const btagKey = "btag";
var AuthProvidersList = /* @__PURE__ */ ((AuthProvidersList2) => {
  AuthProvidersList2[AuthProvidersList2["SOCIAL_NETWORK"] = 0] = "SOCIAL_NETWORK";
  AuthProvidersList2[AuthProvidersList2["EMAIL"] = 1] = "EMAIL";
  AuthProvidersList2[AuthProvidersList2["PHONE"] = 2] = "PHONE";
  AuthProvidersList2[AuthProvidersList2["SMART_ID"] = 3] = "SMART_ID";
  AuthProvidersList2[AuthProvidersList2["MOBILE_ID"] = 4] = "MOBILE_ID";
  AuthProvidersList2[AuthProvidersList2["EPARAKSTS"] = 5] = "EPARAKSTS";
  AuthProvidersList2[AuthProvidersList2["SIGNATURE"] = 6] = "SIGNATURE";
  return AuthProvidersList2;
})(AuthProvidersList || {});
var RegistrationFormConfirmationTypes = /* @__PURE__ */ ((RegistrationFormConfirmationTypes2) => {
  RegistrationFormConfirmationTypes2[RegistrationFormConfirmationTypes2["email"] = 1] = "email";
  RegistrationFormConfirmationTypes2[RegistrationFormConfirmationTypes2["phone"] = 2] = "phone";
  return RegistrationFormConfirmationTypes2;
})(RegistrationFormConfirmationTypes || {});
var LoginTypes = /* @__PURE__ */ ((LoginTypes2) => {
  LoginTypes2[LoginTypes2["email"] = 1] = "email";
  LoginTypes2[LoginTypes2["phone"] = 2] = "phone";
  return LoginTypes2;
})(LoginTypes || {});
var BonusRegistrationUrlTypes = /* @__PURE__ */ ((BonusRegistrationUrlTypes2) => {
  BonusRegistrationUrlTypes2["NONE"] = "none";
  BonusRegistrationUrlTypes2["SPORT"] = "sport";
  BonusRegistrationUrlTypes2["CASINO"] = "casino";
  BonusRegistrationUrlTypes2["VIP"] = "vip";
  return BonusRegistrationUrlTypes2;
})(BonusRegistrationUrlTypes || {});
var AuthorizationTypes = /* @__PURE__ */ ((AuthorizationTypes2) => {
  AuthorizationTypes2[AuthorizationTypes2["AML"] = 4] = "AML";
  AuthorizationTypes2[AuthorizationTypes2["TWO_FACTOR"] = 5] = "TWO_FACTOR";
  AuthorizationTypes2[AuthorizationTypes2["INACTIVE_USER"] = 7] = "INACTIVE_USER";
  return AuthorizationTypes2;
})(AuthorizationTypes || {});
var GviveValidationTypes = /* @__PURE__ */ ((GviveValidationTypes2) => {
  GviveValidationTypes2["PASSED"] = "passed";
  GviveValidationTypes2["FAILED"] = "failed";
  return GviveValidationTypes2;
})(GviveValidationTypes || {});
export {
  AuthProvidersList,
  AuthorizationTypes,
  BonusRegistrationUrlTypes,
  GviveValidationTypes,
  LoginTypes,
  RegistrationFormConfirmationTypes,
  btagKey
};
